import defaultClasses from './styles.module.sass';
import Preview from '../Preview/Preview';
import defaultPreview from './preview.png';
import { ReactComponent as DefaultBackButton } from './svg/back-button.svg';
import { ReactComponent as DefaultTogglePlay } from './svg/toggle-play.svg';
import { ReactComponent as DefaultTogglePause } from './svg/toggle-pause.svg';
import { ReactComponent as DefaultPlay } from './svg/play.svg';
import { ReactComponent as DefaultSpeed } from './svg/speed.svg';
import { ReactComponent as DefaultFullscreenEnter } from './svg/fullscreen-enter.svg';
import { ReactComponent as DefaultFullscreenExit } from './svg/fullscreen-exit.svg';
import { ReactComponent as DefaultVolume } from './svg/volume.svg';
import { ReactComponent as DefaultVolumeMuted } from './svg/volume-muted.svg';
import { ReactComponent as DefaultChapters } from './svg/chapters.svg';
import { ReactComponent as DefaultQuality } from './svg/quality.svg';
import { ReactComponent as DefaultSubtitles } from './svg/subtitles.svg';
import { getBgColor } from '../../../WithBackgroundColor/WithBackgroundColor';
import { IPlayerSkin } from '../types';

// #1
export const defaultSkin: IPlayerSkin = {
  key: 'default',
  label: 'Default',
  classes: defaultClasses,
  component: Preview,
  preview: defaultPreview,
  handles: false,
  handleValue: true,
  tips: true,
  icons: {
    backButton: DefaultBackButton,
    togglePlay: DefaultTogglePlay,
    togglePause: DefaultTogglePause,
    play: DefaultPlay,
    speed: DefaultSpeed,
    fullscreenEnter: DefaultFullscreenEnter,
    fullscreenExit: DefaultFullscreenExit,
    quality: DefaultQuality,
    volume: DefaultVolume,
    volumeMuted: DefaultVolumeMuted,
    chapters: DefaultChapters,
    subtitles: DefaultSubtitles,
  },
  bgColors: {
    togglePlayButton__root: getBgColor,
    progressBar__root: getBgColor,
    progressBar__previews: getBgColor,
    controls__compact_wrapper: getBgColor,
    controls__buttons: getBgColor,
    controls__popover: getBgColor,
    logo: getBgColor,
  },
  bgGradient: {
    logo: getBgColor,
  },
  colors: {
    backButton: getBgColor,
    controls__popoverTip: getBgColor,
    playButton__icon: getBgColor,
  },
  approximateBarHeight: 56,
};
